import { useCallback, useMemo } from 'react';

import { useProductListContext } from '../../context/static/ProductListContext';
import { useStaticContext } from '../../context/static/StaticContext';
import { findDefaultSortingSuffix, isSortingOptionSuffix } from '../../helpers/sortingOptions';

export const useAlgoliaSortingOptions = () => {
  const {
    configuration: { algoliaProductPrimaryIndexName },
  } = useStaticContext();

  const { categoryDetails } = useProductListContext();

  const options = useMemo(
    () =>
      categoryDetails?.sortingV2
        // codes without an Algolia replica index (e.g. SOLR `random`) cannot be sorted by
        ?.filter(({ code }) => isSortingOptionSuffix(code))
        .map(({ code, name, nameEN, value }) => ({
          suffix: code,
          // SAP CX does not always return display names, fall back to the code
          label: name || nameEN || code,
          labelEN: nameEN || name || code,
          value,
        })) ?? [],
    [categoryDetails?.sortingV2]
  );

  const defaultSortingSuffix = findDefaultSortingSuffix(categoryDetails?.sortingV2);

  /**
   * @returns the Algolia index of an offered sorting, the primary index for anything else
   */
  const getIndexName = useCallback(
    (suffix?: string | null) =>
      options.find(option => option.suffix === suffix)?.value ??
      (algoliaProductPrimaryIndexName as string),
    [options, algoliaProductPrimaryIndexName]
  );

  return {
    sortingOptions: options,
    primaryIndex: algoliaProductPrimaryIndexName,
    defaultSortingSuffix,
    getIndexName,
  };
};
